
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {BPagination} from "bootstrap-vue-3";
import {useStore} from "vuex";
import MailingMenu from "@/components/MailingMenu.vue";
import MailingSegmentDTO from "@/models/MailingSegmentDTO";
import MailingSegmentFormDTO from "@/forms/MailingSegmentFormDTO";
import MailingSegmentForm from "@/components/Form/MailingSegmentForm.vue";
import axios from "axios";
import {useNotification} from "@kyvg/vue3-notification";

const defaultMailingForm = {
  id: null,
  query: '',
  name: '',
  type: 'mailing'
} as MailingSegmentFormDTO

export default defineComponent({
  name: 'MailingSegments',
  components: {
    MailingSegmentForm,
    LoaderWrapper,
    BPagination,
    MailingMenu
  },
  setup() {
    const notification = useNotification()
    const store = useStore()
    const mailingSegmentForm = ref<InstanceType<typeof MailingSegmentForm> | null>(null)
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      segmentsModal: false,
      segmentsModalTitle: '',
    });

    const loadData = async () => {
      loader.value?.show();
      await store.dispatch('mailingSegments/loadList')
      loader.value?.hide();
    }

    const save = async () => {
      loaderCreateFrom.value?.show();

      const formData = mailingSegmentForm.value!.getForm();

      try {
        await axios({
          url: formData.id ? '/segments/' + formData.id : '/segments',
          method: formData.id ? 'PUT' : 'POST',
          data: {
            ...formData,
          }
        })

        notification.notify({
          title: formData.id ? "Segment updated" : "Segment created",
        });
      } catch (e) {
        notification.notify({
          title: 'Segment save error',
          text: e.toString(),
          type: 'error',
        });
        loaderCreateFrom.value?.hide();
        return;
      }

      state.segmentsModal = false;
      store.dispatch('mailingSegments/loadList')
      loaderCreateFrom.value?.hide();
    }

    const showEditModal = async (dto: MailingSegmentDTO | null = null) => {
      if (dto) {
        state.segmentsModalTitle = `Edit Segment "${dto.name}"`
      } else {
        state.segmentsModalTitle = 'New Segment'
      }

      mailingSegmentForm.value?.setForm({...defaultMailingForm, ...dto} as MailingSegmentFormDTO)
      state.segmentsModal = true;
    }

    onMounted(async () => {
      loadData();
    });

    return {
      ...toRefs(state),
      loader,
      store,
      loadData,
      showEditModal,
      dateHelper,
      numberFormatter,
      mailingSegmentForm,
      loaderCreateFrom,
      save
    }
  }
})
